import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b110302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first scroll-to" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "THANK YOU FOR BEING PART OF THE ANSWER")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("p", null, " ALL profits and donations go towards helping women and children from Palenque, Colombia that have been severely affected by violence, poverty and exclusion. We focus on education and practical hands-on help like building a food home for homeless children and those who have no access to food. "),
  /*#__PURE__*/_createElementVNode("p", null, "Thank you for considering giving and blessing our vision!")
], -1))
const _hoisted_4 = {
  href: "https://www.paypal.com/paypalme/Loveonpeople",
  target: "_blank"
}
const _hoisted_5 = { class: "second scroll-to" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "HOW CAN YOU HELP?")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Share Your Talents", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Your unique skills have the power to create positive change, no matter where you are. Whether you're skilled in community management, web development, sponsorship management, marketing, copywriting, or translation, we invite you to connect with us. Join our team of dedicated volunteers and help us drive change, leaving a meaningful mark of progress and hope for the less fortunate. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Travel With Us", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Join our compassionate team of volunteers and embark on a life-changing journey to Colombia, where your dedication can uplift the lives of the less fortunate through hands-on support and meaningful interactions. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Single Donation", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " We alone can't do everything, but we all can do something. Make a meaningful impact with a one-time donation that echoes across borders. Any amount helps, any amount makes a difference! Your support will bring immediate relief and lasting change to the lives of the underprivileged in Colombia. ", -1))
const _hoisted_15 = {
  href: "https://www.paypal.com/paypalme/Loveonpeople",
  target: "_blank"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Monthly Donation"),
  /*#__PURE__*/_createElementVNode("span", null, "(Currently Unavailable)")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " While we appreciate your support, we are currently only accepting one-time donations. Your single donation can still make a meaningful impact and bring immediate relief and lasting change to underserved communities in Colombia. Any amount helps, any amount makes a difference! Thank you for joining us in our mission. ", -1))
const _hoisted_19 = {
  href: "https://www.paypal.com/paypalme/Loveonpeople",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lp_sticky_button = _resolveComponent("lp-sticky-button")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("a", _hoisted_4, [
        _createVNode(_component_lp_button, {
          size: "large",
          type: "fill",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("DONATE ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("article", null, [
        _createElementVNode("div", null, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("span", null, [
            _createVNode(_component_router_link, {
              to: "/contact",
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createVNode(_component_lp_button, {
                  onClick: navigate,
                  size: "large",
                  type: "fill",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CONTACT US")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", null, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("span", null, [
            _createVNode(_component_router_link, {
              to: "/contact",
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createVNode(_component_lp_button, {
                  onClick: navigate,
                  size: "large",
                  type: "fill",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" CONTACT US ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_12,
        _createElementVNode("div", null, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("span", null, [
            _createElementVNode("a", _hoisted_15, [
              _createVNode(_component_lp_button, {
                size: "large",
                type: "fill",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" DONATE ONCE ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_16,
        _createElementVNode("div", null, [
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("span", null, [
            _createElementVNode("a", _hoisted_19, [
              _createVNode(_component_lp_button, {
                size: "large",
                type: "fill",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" DONATE ONCE ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_lp_sticky_button)
  ]))
}